import { FeaturedArticleBlock } from './featured-article.block'
import { ArticleCardFeatured } from '../../components'

export const FeaturedArticleComponent = (block: FeaturedArticleBlock) => {
  return <ArticleCardFeatured {...block.article} imagePriority={block.imagePriority} />
}
